import { render, staticRenderFns } from "./BackTenFrameSVG.vue?vue&type=template&id=c9385d56"
import script from "./BackTenFrameSVG.vue?vue&type=script&lang=js"
export * from "./BackTenFrameSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports